import Repository from '../../repositories/RepositoryFactory';
import store from '../index';
const pccRepository = Repository.get('pcc'); /// data/store';

export default {
	namespaced: true,
	state: {
		pccFacilities: [],
		pccFacilitiesById: [],
		pccPatients: [],
		pccPatient: null,
		pccPractitioners: [],
		pccObservations: [],
		pccMedications: [],
		pccConditions: [],
		pccAssessments: [],
		pccMappedLocations: [],
		getMappedPccResidentsForHospital: [],
		pccMappedOrganizations: [],
		myPCCOrganizations: [],
		rateLimits: {
			dailyLimit: 0,
			dailyRemaining: 0,
			dailyResetAt: '',
			minuteLimit: 0,
			minuteRemaining: 0,
			minuteResetAt: null,
			correlationId: '',
		},
		isPCCDisabled: false,
	},
	mutations: {
		STORE_PCC_FACILITIES (state, payload) {
			state.pccFacilities = payload;
		},
		STORE_PCC_FACILITIES_BY_ID (state, payload) {
			state.pccFacilitiesById = payload;
		},
		STORE_PCC_PATIENTS (state, payload) {
			state.pccPatients = payload;
		},
		STORE_PCC_PATIENT (state, payload) {
			state.pccPatient = payload;
		},
		STORE_PCC_PRACTITIONERS (state, payload) {
			state.pccPractitioners = payload;
		},
		STORE_PCC_OBSERVATIONS (state, payload) {
			state.pccObservations = payload;
		},
		STORE_PCC_MEDICATIONS (state, payload) {
			state.pccMedications = payload;
		},
		STORE_PCC_CONDITIONS (state, payload) {
			state.pccConditions = payload;
		},
		STORE_PCC_ASSESSMENTS (state, payload) {
			state.pccAssessments = payload;
		},
		STORE_PCC_MAPPED_LOCATIONS (state, payload) {
			state.pccMappedLocations = payload;
		},
		STORE_PCC_MAPPED_ORGANIZATIONS (state, payload) {
			state.pccMappedOrganizations = payload;
		},
		STORE_PCC_MAPPED_RESIDENTS_FOR_HOSPITAL (state, payload) {
			state.getMappedPccResidentsForHospital = payload;
		},
		STORE_PCC_RATE_LIMITS (state, payload) {
			state.rateLimits = payload;
		},
		STORE_MY_PCC_ORGANIZATIONS (state, payload) {
			state.myPCCOrganizations = payload;
		},
		SET_IS_PCC_DISABLED (state, payload) {
			state.isPCCDisabled = payload;
		},
	},
	actions: {
		async getPCCFacilities ({ commit, dispatch }, pccOrgId) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.getPCCFacilities(pccOrgId);
			commit('STORE_PCC_FACILITIES', response.data);
			return response.data;
		},
		async getPCCFacilityById ({ commit, dispatch }, { pccOrgId, facilitiesById }) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.getPCCFacilityById(pccOrgId, facilitiesById);
			commit('STORE_PCC_FACILITIES_BY_ID', response.data);
			return response.data;
		},
		async getFacilitiesById ({ commit, dispatch }, { pccOrgId, facilitiesById }) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.getFacilitiesById(pccOrgId, facilitiesById);
			commit('STORE_PCC_FACILITIES_BY_ID', response.data);
			return response;
		},
		async getPCCPatients ({ commit, dispatch }, { pccOrgId, pccFacilityId }) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.getPCCPatients(pccOrgId, pccFacilityId);
			commit('STORE_PCC_PATIENTS', response.data);
		},
		async getPatientById ({ commit, dispatch }, { pccOrgId, pccPatientId }) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.getPatientById(pccOrgId, pccPatientId);
			commit('STORE_PCC_PATIENT', response.data);
		},
		async getPractitioners ({ commit, dispatch }, { pccOrgId, pccPatientId, locationId }) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.getPractitioners(pccOrgId, pccPatientId, locationId);
			commit('STORE_PCC_PRACTITIONERS', response.data);
			return response;
		},
		async getObservations ({ commit, dispatch }, { pccOrgId, pccPatientId }) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.getObservations(pccOrgId, pccPatientId);
			commit('STORE_PCC_OBSERVATIONS', response.data);
		},
		async getMedications ({ commit, dispatch }, { pccOrgId, pccFacilityId, pccPatientId }) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.getMedications(pccOrgId, pccFacilityId, pccPatientId);
			commit('STORE_PCC_MEDICATIONS', response.data);
		},
		async getConditions ({ commit, dispatch }, { pccOrgId, pccPatientId }) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.getConditions(pccOrgId, pccPatientId);
			commit('STORE_PCC_CONDITIONS', response.data);
		},
		async getAssessments ({ commit, dispatch }, { pccOrgId, pccPatientId }) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.getAssessments(pccOrgId, pccPatientId);
			commit('STORE_PCC_ASSESSMENTS', response.data);
		},
		async getMappedPccLocations ({ commit, dispatch }) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.getMappedPccLocations();
			commit('STORE_PCC_MAPPED_LOCATIONS', response.data);
			return response;
		},
		async pccLocationDeleteMapping ({ commit, dispatch }, id) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.pccLocationDeleteMapping(id);
			return response;
		},

		async createPCCLocationMappingAndLocation ({ commit, dispatch }, pccLocation) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.createPCCLocationMappingAndLocation(pccLocation);
			return response;
		},
		async updatePCCLocationMapping ({ commit, dispatch }, { id, pccLocation }) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.updatePCCLocationMapping(id, pccLocation);
			return response;
		},
		async deletePCCLocationMapping ({ commit, dispatch }, id) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.deletePCCLocationMapping(id);
			return response;
		},
		async getMappedPccOrganizations ({ commit, dispatch }) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.getMappedPccOrganizations();
			if (response) commit('STORE_PCC_MAPPED_ORGANIZATIONS', response.data);

			return response ?? [];
		},
		async addPccMapForCompany ({ commit, dispatch }, body) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.addPccMapForCompany(body);
			return response;
		},
		async editPccMapForCompany ({ commit, dispatch }, body) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.editPccMapForCompany(body);
			return response;
		},
		async deletePccMapForCompany ({ commit, dispatch }, id) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.deletePccMapForCompany(id);
			return response;
		},
		async getMappedPccResidentsForHospital ({ commit, dispatch }, hospitalId) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.getMappedPccResidentsForHospital(hospitalId);
			commit('STORE_PCC_MAPPED_RESIDENTS_FOR_HOSPITAL', response.data);
			return response;
		},
		async addMappedPccUser ({ commit, dispatch }, body) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.addMappedPccUser(body);
			return response;
		},
		async deleteMappedUser ({ commit, dispatch }, id) {
			await dispatch('getPccRateLimits');

			const response = await pccRepository.deleteMappedUser(id);
			return response;
		},
		async getPccRateLimits ({ commit }) {
			const getPccRateLimitsResponse = await pccRepository.getPccRateLimits();
			if (!getPccRateLimitsResponse || getPccRateLimitsResponse?.isPCCDisabled) return;
			commit('SET_IS_PCC_DISABLED', getPccRateLimitsResponse.isPCCDisabled);
			if (getPccRateLimitsResponse.rateLimits) {
				commit('STORE_PCC_RATE_LIMITS', getPccRateLimitsResponse.rateLimits);
			}
			if (getPccRateLimitsResponse.rateLimits?.severity !== undefined) {
				store.state.appNotifications = [
					getPccRateLimitsResponse.rateLimits,
					...store.state.appNotifications.filter((a) => a.name !== getPccRateLimitsResponse.rateLimits.name),
				];
			}
		},
		async getMyPCCOrganizations ({ commit }) {
			commit('STORE_MY_PCC_ORGANIZATIONS', (await pccRepository.getMyPCCOrganizations()).data);
		},
	},
};
